module.exports = __webpack_public_path__ + "img/icon-warning.dd02cea8.png";